import { useCallback, useMemo, useState } from 'react';
import { IconX } from '@tabler/icons-react';

import { Box } from '@mui/material';

import { ProjectId } from '@types';

import { projectsHandleSelect } from '@actions/projects/projects-handle-select';
import { projectsGetCurrentProject } from '@selectors/projects';

import { useTypedDispatch, useTypedSelector } from '@hooks/store';

import {
  ProfileSelectorModalAvatarStyled,
  ProfileSelectorModalButtonOpenStyled,
  ProfileSelectorModalButtonOpenTypographyStyled,
  ProfileSelectorModalButtonSubmitStyled,
  ProfileSelectorModalMenuItemStyled,
  ProfileSelectorModalMenuItemTypographyStyled,
  ProjectSelectorModalIconButtonStyled,
  ProjectSelectorModalPaperStyled,
  ProjectSelectorModalStyled,
} from './styled';
import {
  ProjectSelectorModalHandleSelect,
  ProjectSelectorModalType,
} from './types';

export const ProjectSelectorModal: ProjectSelectorModalType = (props) => {
  const { options } = props;

  const dispatch = useTypedDispatch();
  const selectedProject = useTypedSelector(projectsGetCurrentProject);
  const [selectedProjectId, setSelectedProjectId] = useState<
    ProjectId | undefined
  >(selectedProject?.id ?? (options[0].value as ProjectId | undefined));
  const [open, setOpen] = useState(false);

  const _selectedProject = useMemo(() => {
    return (
      options.find((option) => option.value === selectedProject?.id) ??
      options[0]
    );
  }, [selectedProject, options]);

  const toggleOpenModal = useCallback(() => {
    setOpen((prev) => !prev);
  }, []);

  const handleSelect: ProjectSelectorModalHandleSelect = useCallback(
    (event, index) => {
      setSelectedProjectId(options[index].value as ProjectId);
    },
    [options]
  );

  const handleConfirm = useCallback(() => {
    dispatch(
      projectsHandleSelect({
        projectId: selectedProjectId as ProjectId,
      })
    );
    toggleOpenModal();
  }, [dispatch, selectedProjectId, toggleOpenModal]);

  return (
    <>
      <ProfileSelectorModalButtonOpenStyled
        onClick={toggleOpenModal}
        size="large"
        variant="outlined"
        color="secondary"
        fullWidth
      >
        <ProfileSelectorModalButtonOpenTypographyStyled>
          {_selectedProject?.label}
        </ProfileSelectorModalButtonOpenTypographyStyled>

        {!_selectedProject?.iconSrc ? null : (
          <ProfileSelectorModalAvatarStyled
            variant="square"
            src={_selectedProject?.iconSrc}
          ></ProfileSelectorModalAvatarStyled>
        )}
      </ProfileSelectorModalButtonOpenStyled>

      <ProjectSelectorModalStyled
        open={open}
        onClose={toggleOpenModal}
        aria-labelledby="modal-project-select"
      >
        <ProjectSelectorModalPaperStyled>
          <ProjectSelectorModalIconButtonStyled
            color="primary" //
            onClick={toggleOpenModal}
          >
            <IconX />
          </ProjectSelectorModalIconButtonStyled>

          <Box>
            {options.map((option, index) => (
              <ProfileSelectorModalMenuItemStyled
                selected={option.value === selectedProjectId}
                key={`${option.value}-${index}`}
                value={option.value}
                disabled={option.disabled}
                onClick={(event) => handleSelect(event, index)}
              >
                <ProfileSelectorModalMenuItemTypographyStyled
                  isSelected={option.value === selectedProjectId}
                >
                  {option.label}
                </ProfileSelectorModalMenuItemTypographyStyled>

                {!option.iconSrc ? null : (
                  <ProfileSelectorModalAvatarStyled
                    variant="square"
                    src={option.iconSrc}
                  ></ProfileSelectorModalAvatarStyled>
                )}
              </ProfileSelectorModalMenuItemStyled>
            ))}
          </Box>

          <ProfileSelectorModalButtonSubmitStyled
            onClick={handleConfirm}
            color="secondary"
            variant="contained"
            size="large"
          >
            Перейти
          </ProfileSelectorModalButtonSubmitStyled>
        </ProjectSelectorModalPaperStyled>
      </ProjectSelectorModalStyled>
    </>
  );
};
